import React from 'react'
import {
  getInternalOrExternalHref,
  isInternalHref,
} from '@marketing-sites/utils'
import Link from 'next/link'
import { textStyles } from '@marketing-sites/ui'

const internalHosts = (process.env['NEXT_PUBLIC_INTERNAL_HOSTS'] ?? '').split(
  ',',
)

export interface InlineHyperlinkProps {
  href: string
  children: React.ReactNode
}
export function InlineHyperlink({ href, children }: InlineHyperlinkProps) {
  const hrefInfo = getInternalOrExternalHref(href, internalHosts)
  if (isInternalHref(hrefInfo)) {
    return (
      <Link href={hrefInfo.href} className={textStyles.a}>
        {children}
      </Link>
    )
  }
  return (
    <a href={href} className={textStyles.a} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}
